import { COLOR_NEUTRALS_3, COLOR_NEUTRALS_6 } from '../colors.constant';

export const colorsFileUploaderLight = {
  colorFileUploaderBackground: COLOR_NEUTRALS_6,
};

export const colorsFileUploaderDark = {
  colorFileUploaderBackground: COLOR_NEUTRALS_3,
};
